import { createFileRoute } from '@tanstack/react-router';
import { QuizEditScreen } from '@/screens/quiz/QuizEditScreen';

export const Route = createFileRoute('/admin/quizzes/$quizId')({
  component: QuizEditScreen,
});
